"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var replace_section_variables_1 = __importDefault(require("../../../utils/replace-section-variables"));
var app_1 = require("../app");
var step_header_1 = __importDefault(require("../components/step-header"));
var useContext = React.useContext, useEffect = React.useEffect;
exports.default = (function () {
    var _a, _b, _c, _d, _e;
    var _f = useContext(app_1.AppContext), changeSize = _f.changeSize, frequency = _f.frequency, shippingIntervalUnitType = _f.shippingIntervalUnitType, mainBundleProduct = _f.mainBundleProduct, setLeftSideImage = _f.setLeftSideImage, size = _f.size;
    if (!mainBundleProduct) {
        return null;
    }
    var productsData = (_a = window.vitaminBundlerApp) === null || _a === void 0 ? void 0 : _a.productsData;
    var selectSizeSettings = (_b = window.vitaminBundlerApp) === null || _b === void 0 ? void 0 : _b.settings.selectSize;
    useEffect(function () {
        var _a;
        (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'vitaminBundle__selectSize' });
    }, []);
    setLeftSideImage((_c = window.vitaminBundlerApp) === null || _c === void 0 ? void 0 : _c.settings.selectSize.leftImage);
    return (React.createElement("div", null,
        React.createElement(step_header_1.default, { title: (_d = window.vitaminBundlerApp) === null || _d === void 0 ? void 0 : _d.settings.selectSize.title, subtitle: (_e = window.vitaminBundlerApp) === null || _e === void 0 ? void 0 : _e.settings.selectSize.subtitle }),
        React.createElement("div", { className: 'padding-bottom-5 flex-dir-column flex-container' }, mainBundleProduct.variants.map(function (variant, ind) {
            var variantSize = parseInt(variant.option1, 10);
            var productData = productsData && productsData[mainBundleProduct.handle];
            var variantData = productData === null || productData === void 0 ? void 0 : productData.variants[variant.id];
            var isSelected = variantSize === size;
            var formattedPrice = (function () {
                var p = (0, format_price_1.default)(variant.price);
                if (p.endsWith('.00')) {
                    var matches = p.match(/(.+?)\./);
                    return matches ? matches[1] : '';
                }
                return p;
            })();
            return (React.createElement("a", { onClick: function () { return changeSize(variantSize); }, className: "select-plan-size display-inline-block padding-3 flex-child-shrink white-space-normal margin-horizontal-5 margin-vertical-2 ".concat(isSelected ? 'select-plan-size-selected' : '') },
                React.createElement("h5", { className: 'font-normal' }, variantData === null || variantData === void 0 ? void 0 :
                    variantData.name,
                    " - ",
                    variantSize,
                    " Vitamins"),
                React.createElement("div", { className: 'margin-bottom-1' },
                    formattedPrice,
                    " / every ",
                    frequency,
                    " ", shippingIntervalUnitType === null || shippingIntervalUnitType === void 0 ? void 0 :
                    shippingIntervalUnitType.toLowerCase()),
                React.createElement("div", { className: 'flex-dir-row flex-container align-justify' },
                    React.createElement("div", { className: 'save-percent padding-horizontal-2 padding-vertical-1 font-size-small' }, selectSizeSettings ? (0, replace_section_variables_1.default)(selectSizeSettings.sizeBottomText, { savings: (variantData === null || variantData === void 0 ? void 0 : variantData.savings) || '' }) : null),
                    ind === mainBundleProduct.variants.length - 2 && (React.createElement("div", { className: 'promotional-text padding-vertical-1 font-size-small' }, "MOST POPULAR")),
                    ind === mainBundleProduct.variants.length - 1 && (React.createElement("div", { className: 'promotional-text padding-vertical-1 font-size-small' }, "BEST SAVINGS")))));
        }))));
});
